<template>
  <Message
    :severity="severity"
    v-bind="messagePassThrough"
    :aria-live="severity === 'info' ? 'off' : 'assertive'"
    :role="severity === 'info' ? 'status' : 'alert'"
  >
    <template #icon>
      <DbcSvg :name="icon" />
    </template>
    <div class="flex items-center gap-2xs">
      <span>
        {{ message }}
      </span>
    </div>
  </Message>
</template>

<script setup lang="ts">
import Message from 'primevue/message'

interface Props {
  severity: 'success' | 'warn' | 'info' | 'attention'
  message: string
  hasBorder?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  hasBorder: false,
})

const rootClasses = ref('')
const icon = ref('')

switch (props.severity) {
  case 'success':
    rootClasses.value = 'bg-success border-success text-success-high'
    icon.value = 'dbc-icon-success'
    break
  case 'attention':
    rootClasses.value = 'bg-attention border-attention text-attention-high'
    icon.value = 'dbc-icon-attention'
    break
  case 'warn':
    rootClasses.value = 'bg-warn border-warn text-warn-high'
    icon.value = 'dbc-icon-warn'
    break
  default:
    rootClasses.value = 'bg-info border-info text-info-high'
    icon.value = 'dbc-icon-info'
}

if (props.hasBorder) {
  rootClasses.value += ' border border-solid '
}

const messagePassThrough = {
  pt: {
    root: {
      class: `p-3 rounded-lg ${rootClasses.value} text-sm flex items-center`,
    },
    content: {
      class: 'flex items-center gap-2xs',
    },
  },
}
</script>
